import React from "react";
import {
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import { useTranslation } from "../i18n/useTranslation";

const StationList = ({ stations, selectedRoutes = [], onRouteToggle }) => {
  const { t, translateRouteName } = useTranslation();
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        border: "1px solid rgba(15,23,42,0.08)",
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 3 }}>
        <Stack spacing={0.5}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {t("station.directory")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("station.subtitle")}
          </Typography>
        </Stack>
        <Chip
          icon={<PlaceIcon />}
          label={t("station.locations", { count: stations.length })}
          sx={{ borderRadius: 999, fontWeight: 600 }}
        />
      </Stack>

      <TableContainer
        sx={{
          maxHeight: 420,
          minHeight: 420,
        }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>{t("station.header.name")}</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>{t("station.header.route")}</TableCell>
              <TableCell sx={{ fontWeight: 700 }} align="right">
                {t("station.header.sequence")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stations.map((station) => {
              const isActive =
                !selectedRoutes.length || selectedRoutes.includes(station.routeId);
              const highlightColor = station.routeColor
                ? `${station.routeColor}15`
                : "rgba(21,101,216,0.08)";
              const routeLabel = translateRouteName(
                station.routeId,
                station.routeName
              );

              return (
                <TableRow
                  hover
                  key={station.code}
                  onClick={() => onRouteToggle && onRouteToggle(station.routeId)}
                  sx={{
                    cursor: onRouteToggle ? "pointer" : "default",
                    bgcolor: isActive ? highlightColor : "inherit",
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <TableCell>
                    <Stack spacing={0.5}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        {station.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {station.code}
                      </Typography>
                    </Stack>
                  </TableCell>
                  <TableCell>{routeLabel}</TableCell>
                  <TableCell align="right">{station.order}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default StationList;
